/// <reference path="../Box/Pane.ts" />
/// <reference path="../Page/ResultItem.ts" />
namespace HA.Core.HTML.Menu {
    //noinspection TsLint
    export class MenuList extends ResultItem {
        /** @param data */
        protected initialize(data: Map<any, any>) {
            super.initialize(data);
            const b = this.findByAttribute("body");
            const list = new List({classes : ["fc", "fw"]});
            this.addToData("ml", list);
            if (b) {
                b.appendChild(this.getMenuList());
                this.addItems(this.get("mid"));
            }
        }

        protected addItems(items: Map<any, any> | []) {
            if (this.has("mim")) {
                const tag = this.getMenuList();
                tag.setModel(this.get("mim"));
                if (items) {
                    items.forEach((i: any) => {
                        tag.addByModel(toMap(i));
                    });
                }
            }
        }

        protected getMenuList() {
            return this.get("ml");
        }
    }

}
